<h3 class="facet-group_heading"
    *ngIf="groupIsShown">{{name}}</h3>

<app-facet-list *ngIf="groupIsShown"
                [facets]="facets"
                [applied]="appliedFacets"
                [open]="open"
                (facetToggled)="toggled($event)"
                (showMoreToggled)="facetgroupToggled()"></app-facet-list>
